import { of } from "rxjs";
var StubApiHelper = /** @class */ (function () {
    function StubApiHelper() {
        this.userObserver = of({
            tk: 'token',
            user: 'user'
        });
    }
    StubApiHelper.prototype.auth = function (hash) { };
    StubApiHelper.prototype.loginImpersonation = function (username) { };
    StubApiHelper.prototype.login = function (username, password, ignoreMaintenance) { };
    StubApiHelper.prototype.redirectImpersonated = function () { };
    StubApiHelper.prototype.redirectLogin = function (response, option) { };
    StubApiHelper.prototype.goToForbidden = function () { };
    StubApiHelper.prototype.isAppMaintenance = function () { };
    StubApiHelper.prototype.logUser = function (response, pass) {
        if (pass === void 0) { pass = null; }
    };
    StubApiHelper.prototype.getWithoutAuth = function (url, data, header) {
        if (data === void 0) { data = null; }
    };
    StubApiHelper.prototype.getWithoutResponse = function (url, data, header, responseType) {
        if (data === void 0) { data = null; }
        if (header === void 0) { header = null; }
        if (responseType === void 0) { responseType = null; }
    };
    StubApiHelper.prototype.get = function (url, data, header) {
        if (data === void 0) { data = null; }
        if (header === void 0) { header = {}; }
    };
    StubApiHelper.prototype.delete = function (url, header) {
        if (header === void 0) { header = {}; }
    };
    StubApiHelper.prototype.post = function () { };
    StubApiHelper.prototype.put = function (url, data, header) {
        if (header === void 0) { header = {}; }
    };
    StubApiHelper.prototype.patch = function (url, data, header) {
        if (header === void 0) { header = {}; }
    };
    StubApiHelper.prototype.handleError = function (error) { };
    StubApiHelper.prototype.setHeaders = function (data) { };
    StubApiHelper.prototype.signUp = function (data) { };
    StubApiHelper.prototype.getCacheBustingQueryString = function () { };
    return StubApiHelper;
}());
export { StubApiHelper };
